import React, {useState} from "react";
import AddPersonForm from "../AddPersonForm/AddPersonForm";
import PeopleList from "../PeopleList/PeopleList";
import "./style.css";

export default function ContactManager(props){
    const [contacts, setContacts] = useState(props.data);
    const addPerson = (name) => {
        setContacts([...contacts, name])
    }

    const deletePerson = (name) => {
        var deleted = contacts.filter(item => item !== name);
        setContacts(deleted);
    }

    return(
        <div>
            <AddPersonForm handleSubmit={addPerson}/>
            <PeopleList data={contacts}
            handleDelete={deletePerson}/>
        </div>
    )
}